import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import type { Column } from 'lumen/utils/constants/benchmark-insight/beni-table-constant-values';

interface HotelBenchmarkInsightTablesHeadersHeaderBeniTableSignature {
  Args: {
    column: Column;
  };
}

const HotelBenchmarkInsightTablesHeadersHeaderBeniTable = <template>
  <div class="flex flex-row items-center justify-end">
    {{#if @column.showUpsellIcon}}
      <div class="mr-200">
        <PrismIcon
          @name="rocket"
          data-test-id="header-beni-table-rocket-icon"
        />
      </div>
    {{/if}}

    {{@column.name}}

    <EmberTooltip @tooltipClass="prism-tooltip">
      {{@column.name}}
    </EmberTooltip>
  </div>
</template> satisfies TOC<HotelBenchmarkInsightTablesHeadersHeaderBeniTableSignature>;

export default HotelBenchmarkInsightTablesHeadersHeaderBeniTable;
